import { render, staticRenderFns } from "./Revalidation.vue?vue&type=template&id=70ceaccf&scoped=true"
import script from "./Revalidation.vue?vue&type=script&lang=js"
export * from "./Revalidation.vue?vue&type=script&lang=js"
import style0 from "./Revalidation.vue?vue&type=style&index=0&id=70ceaccf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70ceaccf",
  null
  
)

export default component.exports